export default __webpack_public_path__ + "static/media/demo-1.e1456e85.png";